import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alert alert-danger mb-6"
}
const _hoisted_2 = {
  key: 2,
  class: "mt-6 mb-6"
}
const _hoisted_3 = { class: "mb-6" }
const _hoisted_4 = { class: "seq-echeque-display" }
const _hoisted_5 = {
  key: 2,
  class: "mt-6 mb-6"
}
const _hoisted_6 = { class: "row gy-5 g-xl-8" }
const _hoisted_7 = {
  type: "button",
  ref: "addAccountModalButton",
  class: "btn btn-primary er fs-6 px-8 py-4",
  "data-bs-toggle": "modal",
  "data-bs-target": `#add_new_accountmodal`
}
const _hoisted_8 = {
  type: "button",
  ref: "encodeNowSealproModalButton",
  class: "btn btn-primary er fs-6 px-8 py-4",
  "data-bs-toggle": "modal",
  "data-bs-target": `#encode_now_sealpromodal`
}
const _hoisted_9 = {
  type: "button",
  ref: "encodeNowSealproAutoCoverageModalButton",
  class: "btn btn-primary er fs-6 px-8 py-4",
  "data-bs-toggle": "modal",
  "data-bs-target": `#encode_now_sealproautocoverage_modal`
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_DashboardProfileHeader = _resolveComponent("DashboardProfileHeader")
  const _component_ECShopAdvisory = _resolveComponent("ECShopAdvisory")
  const _component_PMAReminderNotice = _resolveComponent("PMAReminderNotice")
  const _component_router_view = _resolveComponent("router-view")
  const _component_HeroBalanceCard = _resolveComponent("HeroBalanceCard")
  const _component_DashboardMovableBlock = _resolveComponent("DashboardMovableBlock")
  const _component_OVISequenceOverview = _resolveComponent("OVISequenceOverview")
  const _component_OVIAdvisory = _resolveComponent("OVIAdvisory")
  const _component_SealProEncode = _resolveComponent("SealProEncode")
  const _component_SealProAutoCoverage = _resolveComponent("SealProAutoCoverage")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    (_ctx.loadError)
      ? (_openBlock(), _createBlock("div", _hoisted_1, " Unable to load dashboard data. Please refresh the page or try again later. "))
      : _createCommentVNode("", true),
    (!_ctx.loading && !_ctx.loadError)
      ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_DashboardProfileHeader, {
            user: _ctx.user,
            rankPrimeImage: _ctx.rankPrimeImage,
            rankPrime: _ctx.rankPrime,
            currentRank: _ctx.currentRank,
            showRankImage: _ctx.showRankImage,
            showAddAccount: true,
            showLifetimeIncome: false,
            coverPhoto: _ctx.coverPhoto,
            onAddAccount: _ctx.addAccount
          }, null, 8, ["user", "rankPrimeImage", "rankPrime", "currentRank", "showRankImage", "coverPhoto", "onAddAccount"]),
          _createVNode(_component_ECShopAdvisory),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.aboveBlocks, (block) => {
            return (_openBlock(), _createBlock(_component_DashboardMovableBlock, {
              key: 'above-' + block.id,
              label: _ctx.blockLabel(block.id),
              "can-move-up": _ctx.canMoveUp(block.id),
              "can-move-down": _ctx.canMoveDown(block.id),
              onMoveUp: ($event: any) => (_ctx.moveUp(block.id)),
              onMoveDown: ($event: any) => (_ctx.moveDown(block.id))
            }, {
              default: _withCtx(() => [
                (block.id === 'pma')
                  ? (_openBlock(), _createBlock(_component_PMAReminderNotice, { key: 0 }))
                  : (block.id === 'navPage')
                    ? (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
                    : (block.id === 'lifetime')
                      ? (_openBlock(), _createBlock("div", _hoisted_2, [
                          _createVNode(_component_HeroBalanceCard, {
                            label: "Lifetime Income",
                            amount: _ctx.lifetimeIncome,
                            currencySymbol: _ctx.lifetimeCurrency
                          }, null, 8, ["amount", "currencySymbol"])
                        ]))
                      : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["label", "can-move-up", "can-move-down", "onMoveUp", "onMoveDown"]))
          }), 128)),
          _createVNode(_component_OVISequenceOverview, { dashboardData: _ctx.dashboarddata }, null, 8, ["dashboardData"]),
          _createVNode(_component_OVIAdvisory),
          _withDirectives(_createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("img", {
                src: _ctx.echequeUrl,
                alt: "Your E-Cheque",
                class: "seq-echeque-display__img",
                onError: _cache[1] || (_cache[1] = ($event: any) => (_ctx.echequeUrlNoError = false))
              }, null, 40, ["src"])
            ])
          ], 512), [
            [_vShow, _ctx.showEChequeImage && _ctx.echequeUrlNoError]
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.belowBlocks, (block) => {
            return (_openBlock(), _createBlock(_component_DashboardMovableBlock, {
              key: 'below-' + block.id,
              label: _ctx.blockLabel(block.id),
              "can-move-up": _ctx.canMoveUp(block.id),
              "can-move-down": _ctx.canMoveDown(block.id),
              onMoveUp: ($event: any) => (_ctx.moveUp(block.id)),
              onMoveDown: ($event: any) => (_ctx.moveDown(block.id))
            }, {
              default: _withCtx(() => [
                (block.id === 'pma')
                  ? (_openBlock(), _createBlock(_component_PMAReminderNotice, { key: 0 }))
                  : (block.id === 'navPage')
                    ? (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
                    : (block.id === 'lifetime')
                      ? (_openBlock(), _createBlock("div", _hoisted_5, [
                          _createVNode(_component_HeroBalanceCard, {
                            label: "Lifetime Income",
                            amount: _ctx.lifetimeIncome,
                            currencySymbol: _ctx.lifetimeCurrency
                          }, null, 8, ["amount", "currencySymbol"])
                        ]))
                      : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["label", "can-move-up", "can-move-down", "onMoveUp", "onMoveDown"]))
          }), 128))
        ], 64))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_6, [
      _withDirectives(_createVNode("button", _hoisted_7, " Click here ", 512), [
        [_vShow, false]
      ]),
      _createVNode(_component_SealProEncode, {
        sealpro_encode_modal: 'add_new_accountmodal',
        firstCoverage: _ctx.firstCoverage,
        allowClose: _ctx.allowClose,
        inputActivationDetail: _ctx.inputActivationDetail,
        isAddAccount: true,
        allowChangeName: false
      }, null, 8, ["firstCoverage", "allowClose", "inputActivationDetail"]),
      _withDirectives(_createVNode("button", _hoisted_8, " Click here ", 512), [
        [_vShow, false]
      ]),
      _createVNode(_component_SealProEncode, {
        key: _ctx.encode_now_sealpro_key,
        firstCoverage: _ctx.firstCoverage,
        sealpro_encode_modal: 'encode_now_sealpromodal',
        allowClose: false,
        inputActivationDetail: false,
        isAddAccount: false,
        allowChangeName: _ctx.allowChangeName
      }, null, 8, ["firstCoverage", "allowChangeName"]),
      _withDirectives(_createVNode("button", _hoisted_9, " Click here ", 512), [
        [_vShow, false]
      ]),
      _createVNode(_component_SealProAutoCoverage, {
        key: _ctx.encode_now_sealproautocoverage_key,
        firstCoverage: _ctx.firstCoverage,
        sealpro_encode_modal: 'encode_now_sealproautocoverage_modal',
        allowClose: false,
        inputActivationDetail: false,
        isAddAccount: false,
        allowChangeName: _ctx.allowChangeName
      }, null, 8, ["firstCoverage", "allowChangeName"])
    ])
  ], 64))
}